import React, { useState, useContext, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import './Pdp.scss';
import { isMobile, isDesktop, isIpad } from '../../global/ScreenSizeHelper';
import Transition from './../../transition';
import { OnTheMenuDataContext } from '../../context-api/OnTheMenuDataProvider';
import { getUrlParams, getUrlPath, getUrlFullPath, removeParamFromUrl } from '../../global/getUrl';
import { Error404 } from '../../composed/Error404/Error404';
import PageBase from '../../composed/pagebase/pagebase';
import { Cart, EmptyCart } from '../../composed/cart/Cart';
import './Pdp.scss';
import AlertDialog from '../../atomic/Dialog/Dialog';
import imageUrlTransformation from '../../global/imageUrlTransformation';
import { screenSize } from '../../global/ScreenSizeHelper';
import Loader from '../../composed/Loader/Loader';
import fallBackImage from '../../global/assets/svg/ImageError.svg';
import { localStorageKeys } from '../../global/constants';
import { QuantityPicker } from '../../atomic/QuantityPicker/QuantityPicker';
import AtomicButton from '../../atomic/button/AtomicButton';
import { LoginDataContext } from '../../context-api/LoginDataProvider';
import { Avatar, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {
  STORE_CLOSED_SHORT_TIME,
  STORE_NOT_FOUND_404,
  PRODUCT_NOT_FOUND_404,
  SpecialMarkingIcons,
} from '../../global/assets/Icons';
import Ingredients from './Ingredients';
import RadioGroupAtomic from '../../atomic/radiogroup/RadioGroup';
import moment from 'moment';
import TextTransformation from '../../global/textTransformation';
import { GlobalStateDataContext } from '../../context-api/GlobalStateDataProvider';
import { CheckoutDataContext } from '../../context-api/CheckoutDataProvider';

const Pdp = () => {
  const navigate = useNavigate();
  const RedirectToLogin = async () => await navigate('/login');
  const RedirectToUpgradeSubscription = async () => await navigate('/upgradesubscription');
  const RedirectToCustAcctSubscription = async () =>
    await navigate('/customeraccount/subscription');
  const RedirectToCustAcctCard = async () => await navigate('/customeraccount/cards');
  const RedirectToAddAddress = async () => await navigate(`/customeraccount/deliveryaddress`);

  const { onLoadInfoResponse } = useContext(GlobalStateDataContext);
  const [openAlert, setOpenAlert] = useState({
    show: false,
    type: null,
    productType: null,
    productSku: null,
    index: -1,
    productCategory: null,
    triggerFrom: null,
    product: null,
    cartItems: null,
  });

  const {
    storeName,
    setStoreName,
    getProductList,
    productsData,
    setProductsData,
    kitchenData,
    setkitchenData,
    storeAccountType,
    setStoreAccountType,
    getKitchenList,
    restaurantList,
    sortedKitchenData,
    setSortedKitchenData,
    cartItems,
    setCartItems,
    onClickCheckout,
    PromoSpendRequiredAmount,
    oneTimeMeal,
    setOneTimeMeal,
    howManyPerson,
    setHowManyPerson,
  } = useContext(OnTheMenuDataContext);
  const { orderConfirmationData, setOrderConfirmationData, setPromoCodeOrderSummary } =
    useContext(CheckoutDataContext);

  const { storename: urlStoreName, productname: urlProductName } = getUrlParams();
  const productName = decodeURIComponent(urlProductName);
  const { ZIP_CODE, KITCHEN_NAMES, DEBUG_LOGOUT_POINT } = localStorageKeys;
  const localStorageKitchens = localStorage.getItem(KITCHEN_NAMES);
  const [open, setOpen] = useState(false);
  const [isAlertOpen, setAlertOpen] = useState(false);
  const [displayText, setdisplayText] = useState('');
  const [buttonAgreeLabel, setButtonAgreeLabel] = useState('Okay');
  const [iconForAlert, setIconForAlert] = useState(null);
  const [iconWidth, setIconWidth] = useState('125px');
  const [showAgreeButton, setshowAgreeButton] = useState(true);
  const [showDisagreeButton, setshowDisagreeButton] = useState(true);
  const [imageError, setImageError] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [toppingQuantity, setToppingQuantity] = useState({});
  const [dataReady, setDataReady] = useState(false);
  const [productQuantity, setProductQuantity] = useState(1);
  const {
    loginData,
    onLogin,
    isLoggedIn,
    onCustomerInformationApiHandler,
    customerInfoData,
    onLogout,
    setCustomerInfoData,
    setLoginData,
  } = useContext(LoginDataContext);
  const { loading, data, success, errorMessage } = customerInfoData;
  const custInfoData = data?.data || [];
  const IsCartItems =
    cartItems?.mealItems?.length > 0 ||
    cartItems?.nonMealItems?.length > 0 ||
    cartItems?.promotionalItems?.length > 0;
  const custActType = custInfoData?.user_Info?.account_type === 'Subscription';
  const custCardDecline = custInfoData?.user_Info?.reason_status === 'Card decline';
  const custCardAddingPending = custInfoData?.user_Info?.reason_status === 'Card adding pending';
  const notZeroPlates = custInfoData?.available_plates > 0;
  const custAccountReason = custInfoData?.user_Info?.reason_status;
  const addresses = custInfoData?.delivery_address || [];
  const [selectedFreeTopping, setSelectedFreeTopping] = useState({});
  const [freeToppings, setFreeToppings] = useState([]);
  const [paidToppings, setPaidToppings] = useState([]);
  const [addToCartDisabled, setAddToCartDisabled] = useState(false);
  const [ActiveButton, setActiveButton] = useState('ingrediant');
  const triggerLogout = async () => await onLogout();
  const setLocalStorageDebug = async (param1, param2) => localStorage.setItem(param1, param2);
  const product_image_url =
    'https://res.cloudinary.com/dagb9zfyf/image/upload/v1697994756/TestCloud9.jpg';
  const DataKitchenInfo = productsData?.data?.data?.[urlStoreName]; // Sorting kitchen information from /GetProduct API
  const StoreClosedForShortTime = sortedKitchenData?.storeIsClosedForShortTime;

  const IsPdpPage = getUrlPath().includes('/pdp');

  const initfunc = async () => {
    await getProductList({
      kitchen_names: [urlStoreName],
      product_name: productName,
    });
  };

  let productDataFromUrl = null;
  if (productsData?.data) {
    // getting required product data when productsData.data is defined, when url is loaded
    const items = productsData.data?.categorizedProducts?.[urlStoreName];
    Object.keys(items).forEach((key) => {
      Object.keys(items[key]).forEach((category) => {
        if (items[key][category]) {
          const requiredProduct = items[key][category].find(
            (item) => item.product_name === productName
          );
          if (requiredProduct) {
            productDataFromUrl = requiredProduct;
          }
        }
      });
    });
  }

  // console.log('productDataFromUrl', productDataFromUrl, productsData);
  const productDetail = productDataFromUrl === null ? productsData : productDataFromUrl;
  const cartProductType =
    productDetail?.product_type === 'meal_item' ? 'mealItems' : 'nonMealItems';
  const inCartAddedProduct = cartItems?.[cartProductType]?.find(
    (item) => item.product_sku === productDetail?.product_sku
  );

  const apiCallCustomerInfo = async () => {
    await onCustomerInformationApiHandler();
  };

  const someThingWentWrong = async (verbage) => {
    if (StoreClosedForShortTime) {
      setdisplayText(verbage);
      setOpen(true);
      setProductsData({});
      setshowDisagreeButton(false);
      setshowAgreeButton(true);
      setButtonAgreeLabel('Redirect to OnTheMenu');
      return;
    }

    setdisplayText(verbage);
    setOpen(true);
    setProductsData({});
    setshowDisagreeButton(false);
    setshowAgreeButton(false);
    setTimeout(() => {
      removeParamFromUrl('storename');
      setOpen(false);
      navigate('/onthemenu');
    }, 9000);
  };

  const addressIsMissing = async () => {
    setdisplayText('Please provide your complete address to check availability.');
    setOpen(true);
    setshowDisagreeButton(true);
    setshowAgreeButton(true);
    setButtonAgreeLabel('Add Address');
  };

  const ToggleLoader = () => {
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  };

  const onImageLoad = () => {
    setImageLoaded(true);
  };

  const onImageError = () => {
    setImageError(true);
    setImageLoaded(true);
  };

  const setStoreTyp =
    storeAccountType === null
      ? productsData?.data?.data[urlStoreName]?.account_type
      : storeAccountType;
  const handleClickRedirect = async () => {
    setStoreAccountType(setStoreTyp);
    setStoreName(urlStoreName);
    setProductsData({});
    await navigate(`/onthemenu/storemenu?storename=${urlStoreName}`);
  };

  const updateSelectedToppingQuantity = (topping, qty) => {
    setPromoCodeOrderSummary({});
    const newToppingQuantity = { ...toppingQuantity };
    newToppingQuantity[topping.topping_name] = qty;
    setToppingQuantity({ ...newToppingQuantity });
  };

  const getRemainingCategorisedProduct = () => {
    const mealPlanMap = {
      'one person': 1,
      'two person': 2,
      'four person': 4,
    };
    let mealPlan = custInfoData?.meal_Package?.meal_plan;
    if (oneTimeMeal && howManyPerson) {
      mealPlan = howManyPerson;
    }
    const mealPlanValue = mealPlanMap[mealPlan];
    const allowedMealPlanOffering = {};
    Object.keys(sortedKitchenData?.meal_offering).forEach((key) => {
      allowedMealPlanOffering[key] = mealPlanValue * sortedKitchenData?.meal_offering[key];
    });

    const inCartMealItem = {};
    cartItems?.mealItems?.forEach((mealItem) => {
      if (!inCartMealItem[mealItem.product_category]) {
        inCartMealItem[mealItem.product_category] = 0;
      }
      inCartMealItem[mealItem.product_category] += 1;
    });

    // console.log("inCartMealItem", inCartMealItem);
    return (
      allowedMealPlanOffering[productDetail?.product_category] -
      (inCartMealItem[productDetail?.product_category] || 0)
    );
  };

  useEffect(() => {
    if (
      isLoggedIn &&
      custActType &&
      notZeroPlates &&
      productDetail?.product_type === 'meal_item' &&
      productDetail?.available_quantity > 0 &&
      sortedKitchenData
    ) {
      const remainingCategorizedProduct = getRemainingCategorisedProduct();
      if (remainingCategorizedProduct > 0) {
        setAddToCartDisabled(false);
      }
    }
  }, [JSON.stringify(cartItems)]);

  const onAddToCart = () => {
    //Empty OrderConfirmationData
    setOrderConfirmationData({});
    setPromoCodeOrderSummary({});

    if (
      (!isLoggedIn || (isLoggedIn && !custActType)) &&
      productDetail?.product_type === 'meal_item' &&
      !oneTimeMeal
    ) {
      navigate('/upgradesubscription');
      return;
    }

    if (
      sortedKitchenData?.account_type !== 'promotional kitchen' &&
      (cartItems?.mealItems?.length > 0 || cartItems?.nonMealItems?.length > 0)
    ) {
      const kitchenNameOfAddedProducts =
        cartItems?.mealItems?.[0]?.kitchen_name || cartItems?.nonMealItems?.[0]?.kitchen_name;
      if (kitchenNameOfAddedProducts && urlStoreName !== kitchenNameOfAddedProducts) {
        setAlertOpen(true);
        return;
      }
    }

    // Kuldeep changed condition from
    // if (isLoggedIn && custActType && notZeroPlates) && productDetail?.product_type === 'meal_item' && productDetail?.available_quantity > 0) {
    if (
      ((isLoggedIn && custActType && notZeroPlates) ||
        (!custActType && oneTimeMeal && howManyPerson)) &&
      productDetail?.product_type === 'meal_item' &&
      productDetail?.available_quantity > 0
    ) {
      const remainingCategorizedProduct = getRemainingCategorisedProduct();
      if (remainingCategorizedProduct > 0) {
        // add to cart logic
        const newCartItems = JSON.parse(JSON.stringify(cartItems));
        if (!newCartItems?.mealItems) {
          newCartItems.mealItems = [];
        }
        newCartItems?.mealItems?.push({
          product_name: productDetail?.product_name,
          selectedQuantity: 1,
          price: productDetail?.price,
          available_quantity: productDetail?.available_quantity,
          product_category: productDetail?.product_category,
          product_sku: productDetail?.product_sku,
          kitchen_name: productDetail?.kitchen_name,
          kitchen_id: productDetail?.kitchen_id,
        });

        setCartItems({ ...newCartItems });
        if (remainingCategorizedProduct === 1) {
          setAddToCartDisabled(true);
        }
      }
    }

    if (productDetail?.product_type === 'non_meal_item') {
      // add to cart logic
      const newCartItems = JSON.parse(JSON.stringify(cartItems));
      if (!newCartItems?.nonMealItems) {
        newCartItems.nonMealItems = [];
      }
      const productInCartIndex = newCartItems.nonMealItems?.findIndex(
        (item) =>
          item.product_name === productDetail?.product_name &&
          item.product_category === productDetail?.product_category
      );
      const anyToppingAdded = Object.keys(toppingQuantity).some((t) => toppingQuantity[t] > 0);
      let requiredToppings = [];
      if (anyToppingAdded) {
        requiredToppings = paidToppings
          ?.filter((t) => toppingQuantity[t.topping_name] > 0)
          .map((t) => ({
            ...t,
            selectedQuantity: toppingQuantity[t.topping_name],
          }));
      }
      const anyFreeToppingAdded = Object.keys(selectedFreeTopping)?.length > 0;
      console.log('anyFreeToppingAdded ', anyFreeToppingAdded, productInCartIndex);
      if (anyFreeToppingAdded) {
        requiredToppings = [
          ...requiredToppings,
          {
            ...selectedFreeTopping,
            selectedQuantity: productQuantity,
          },
        ];
      }
      let productInConsideration = null;
      if (productQuantity > 0 && productInCartIndex > -1) {
        if (productDetail?.product_promotion?.buy_one_get_one_free && productQuantity > 1) {
          newCartItems.nonMealItems[productInCartIndex].promotion = {
            type: 'buy_one_get_one_free',
            active: true,
          };
        } else if (productDetail?.product_promotion?.buy_two_get_one_free && productQuantity > 2) {
          newCartItems.nonMealItems[productInCartIndex].promotion = {
            type: 'buy_two_get_one_free',
            active: true,
          };
        } else if (
          productDetail?.product_promotion?.buy_one_get_half_price &&
          productQuantity > 1
        ) {
          newCartItems.nonMealItems[productInCartIndex].promotion = {
            type: 'buy_one_get_half_price',
            active: true,
          };
        } else {
          delete newCartItems.nonMealItems[productInCartIndex].promotion;
        }
        newCartItems.nonMealItems[productInCartIndex].selectedQuantity = productQuantity;
        if (anyToppingAdded || anyFreeToppingAdded) {
          newCartItems.nonMealItems[productInCartIndex].extra_toppings = requiredToppings;
        }
        productInConsideration = newCartItems.nonMealItems[productInCartIndex];
      } else if (productQuantity > 0) {
        const productObj = {
          product_name: productDetail?.product_name,
          selectedQuantity: productQuantity,
          available_quantity: productDetail?.available_quantity,
          price: productDetail?.price,
          product_category: productDetail?.product_category,
          product_sku: productDetail?.product_sku,
          kitchen_name: productDetail?.kitchen_name,
          kitchen_id: productDetail?.kitchen_id,
        };
        if (productDetail?.product_promotion?.buy_one_get_one_free) {
          productObj.promotion = {
            type: 'buy_one_get_one_free',
            active: productObj.selectedQuantity > 1,
          };
        } else if (productDetail?.product_promotion?.buy_two_get_one_free) {
          productObj.promotion = {
            type: 'buy_two_get_one_free',
            active: productObj.selectedQuantity > 2,
          };
        } else if (productDetail?.product_promotion?.buy_one_get_half_price) {
          productObj.promotion = {
            type: 'buy_one_get_half_price',
            active: productObj.selectedQuantity > 1,
          };
        }
        if (anyToppingAdded || anyFreeToppingAdded) {
          productObj.extra_toppings = requiredToppings;
        }
        newCartItems.nonMealItems.push(productObj);
      } else {
        const productObj = {
          product_name: productDetail?.product_name,
          selectedQuantity: productQuantity,
          available_quantity: productDetail?.available_quantity,
          price: productDetail?.price,
          product_category: productDetail?.product_category,
          product_sku: productDetail?.product_sku,
          kitchen_name: productDetail?.kitchen_name,
          kitchen_id: productDetail?.kitchen_id,
        };
        productInConsideration = productObj;
        newCartItems.nonMealItems[productInCartIndex] = productObj;
      }
      const BranchFlag = onLoadInfoResponse?.data?.data?.data?.operationFlags;
      let subtotal = 0;
      newCartItems?.nonMealItems?.forEach((item) => {
        const productQty = item.selectedQuantity;
        let price = item.selectedQuantity * item.price;
        if (
          item?.promotion?.type === 'buy_one_get_one_free' &&
          item?.promotion?.active &&
          productQty > 1
        ) {
          price = (productQty - Math.floor(productQty / 2)) * item.price;
        } else if (
          item?.promotion?.type === 'buy_two_get_one_free' &&
          item?.promotion?.active &&
          productQty > 2
        ) {
          price = (productQty - Math.floor(productQty / 3)) * item.price;
        } else if (
          item?.promotion?.type === 'buy_one_get_half_price' &&
          item?.promotion?.active &&
          productQty > 1
        ) {
          price =
            (productQty - Math.floor(productQty / 2) + Math.floor(productQty / 2) / 2) * item.price;
        }
        subtotal += price;
        if (item.extra_toppings) {
          item.extra_toppings.forEach((t) => {
            subtotal += t.selectedQuantity * t.topping_price;
          });
        }
      });
      subtotal = subtotal.toFixed(2);
      const expectedSubTotal = +subtotal;
      if (
        expectedSubTotal < PromoSpendRequiredAmount() &&
        (sortedKitchenData?.agreedForFreeComboPromo ||
          BranchFlag?.branchAgreedFreeComboPromoForPayAsYouGo) &&
        (!BranchFlag?.branchAgreedFreeComboPromoForSubscription ||
          (BranchFlag?.branchAgreedFreeComboPromoForSubscription &&
            !cartItems?.mealItems?.length)) &&
        cartItems?.promotionalItems?.length > 0
      ) {
        setOpenAlert({
          show: true,
          type: 'both',
          productType: 'nonMealItem',
          triggerFrom: 'quantityUpdate',
          product: productInConsideration,
          productSku: productDetail?.product_sku,
          productCategory: productDetail?.product_category,
        });
        return;
      } else if (
        expectedSubTotal < PromoSpendRequiredAmount() &&
        (sortedKitchenData?.agreedForFreeComboPromo ||
          BranchFlag?.branchAgreedFreeComboPromoForPayAsYouGo) &&
        cartItems?.promotionalItems?.some((item) => item.product_category === 'payasyougo_combo')
      ) {
        setOpenAlert({
          show: true,
          type: 'payasyougo_combo',
          productType: 'nonMealItem',
          triggerFrom: 'quantityUpdate',
          product: productInConsideration,
          productSku: productDetail?.product_sku,
          productCategory: productDetail?.product_category,
        });
        return;
      }

      if (productQuantity === 0) {
        newCartItems.nonMealItems = newCartItems.nonMealItems.filter(
          (item, i) =>
            !(item.product_sku === productDetail?.product_sku && i === productInCartIndex)
        );
      }

      setCartItems({ ...newCartItems });

      if (
        productDetail?.available_quantity -
          (cartItems?.nonMealItems?.find(
            (item) =>
              item.product_name === productDetail?.product_name &&
              item.product_category === productDetail?.product_category
          )?.selectedQuantity || 0) ===
        0
      ) {
        // setDisabledAddToCartBtn_NonMealItem();
        // out of stock
      }
    }
  };

  const onAlertAgree = () => {
    if (buttonAgreeLabel === 'Add Address') {
      RedirectToAddAddress();
      return;
    }
    if (StoreClosedForShortTime) {
      removeParamFromUrl('storename');
      setOpen(false);
      navigate('/onthemenu');
    } else {
      setCartItems({});
      setAlertOpen(false);
    }
  };

  const onAlertDisagree = () => {
    setAlertOpen(false);
  };

  const onFreeToppingSelected = (v) => {
    const selectedTopping = {
      ...freeToppings?.find((t) => t.topping_name === v.target.value),
      selectedQuantity: productQuantity,
    };

    setSelectedFreeTopping({ ...selectedTopping });
  };

  let totalPriceOfNonMealItems = 0;
  if (productDetail?.price) {
    let price = productQuantity * productDetail?.price;
    if (productDetail?.product_promotion?.buy_one_get_one_free && productQuantity > 1) {
      price = (productQuantity - Math.floor(productQuantity / 2)) * productDetail?.price;
    } else if (productDetail?.product_promotion?.buy_two_get_one_free && productQuantity > 2) {
      price = (productQuantity - Math.floor(productQuantity / 3)) * productDetail?.price;
    } else if (productDetail?.product_promotion?.buy_one_get_half_price && productQuantity > 1) {
      price =
        (productQuantity - Math.floor(productQuantity / 2) + Math.floor(productQuantity / 2) / 2) *
        productDetail?.price;
    }
    totalPriceOfNonMealItems += price;
    if (paidToppings?.length > 0) {
      paidToppings.forEach((t) => {
        totalPriceOfNonMealItems += toppingQuantity[t.topping_name] * t.topping_price;
      });
    }
  }

  const getProductCount = (productName) => {
    if (productDetail?.product_type === 'non_meal_item') {
      return cartItems?.nonMealItems?.find((item) => {
        return item.product_name === productName;
      })?.selectedQuantity;
    }
    if (productDetail?.product_type === 'meal_item') {
      let count = 0;
      cartItems?.mealItems?.forEach((item) => {
        if (item.product_name === productName) {
          count++;
        }
      });

      return count;
    }
  };
  const productCount = getProductCount(productDetail?.product_name);

  const ButtonSwitch = () => {
    // When Customer is logged in and account type is susbcription and have 1 or more plates available
    if (
      isLoggedIn &&
      ((custActType && notZeroPlates) || (!custActType && oneTimeMeal && howManyPerson))
    ) {
      return { buttonLabel: 'Add to cart', handleMethod: onAddToCart };
    }

    // When Customer is Not logged in
    if (!isLoggedIn) {
      return { buttonLabel: 'Login', handleMethod: RedirectToLogin };
    }

    // When Customer is logged in  and account type is payasyougo
    if (isLoggedIn && !custActType && !oneTimeMeal) {
      return {
        buttonLabel: 'Upgrade to subscription',
        handleMethod: RedirectToUpgradeSubscription,
      };
    }

    // When Customer is logged in  and account type is subscription and dont have enough plates and reason status is Customer unsubscribed
    if (
      isLoggedIn &&
      custActType &&
      !notZeroPlates & (custAccountReason === 'Customer unsubscribed')
    ) {
      return {
        buttonLabel: 'Reactivate subscrition',
        handleMethod: RedirectToCustAcctSubscription,
      };
    }

    // When Customer is logged in  and account type is subscription and dont have enough plates and reason status is Card decline (or)Card adding pending
    if (
      isLoggedIn &&
      custActType &&
      !notZeroPlates &
        (custAccountReason === 'Card decline' || custAccountReason === 'Card adding pending')
    ) {
      return { buttonLabel: 'Update Payment Information', handleMethod: RedirectToCustAcctCard };
    }

    if (isLoggedIn && custAccountReason === 'Inactive by admin') {
      triggerLogout();
      setLocalStorageDebug(DEBUG_LOGOUT_POINT, 'pdp() NO666');
      RedirectToLogin();
    }
  };

  const onButtonClick = (e) => {
    setActiveButton(e.target.value);
  };

  const ActiveStyle = {
    margin: '0px 3px 5px 0px',
    color: '#181436',
    background: 'none',
    border: 'none',
    borderBottom: isMobile ? 'none' : '2px solid #FF7A28',
    fontSize: isMobile ? '14px' : '16px',
    fontFamily: 'Roboto Bold',
    cursor: 'pointer',
  };

  const InActiveStyle = {
    margin: '0px 3px 5px 0px',
    color: '#8B8995',
    border: 'none',
    borderBottom: 'none',
    fontSize: '12px',
    background: 'none',
    fontFamily: 'Roboto Regular',
    cursor: 'pointer',
  };

  useEffect(() => {
    if (productsData?.data === null && productsData?.errors === null) {
      initfunc();
    }

    if (isLoggedIn && custInfoData.length === 0) {
      apiCallCustomerInfo();
    }

    setIsLoading(true);
  }, []);

  useEffect(() => {
    ToggleLoader();
  }, []);

  useEffect(() => {
    if (productDetail?.product_name && !dataReady) {
      const toppingQuantity = {};
      const freeToppings = [];
      const paidToppings = [];
      for (let i = 0; i < productDetail?.extra_toppings?.length; i++) {
        const t = productDetail?.extra_toppings[i];
        const inCartPaidTopping = inCartAddedProduct?.extra_toppings?.find(
          (i) => i.topping_name === t.topping_name && i.topping_price > 0
        );
        if (inCartPaidTopping) {
          toppingQuantity[t.topping_name] = inCartPaidTopping.selectedQuantity;
          paidToppings.push(t);
        } else if (t.topping_price > 0) {
          toppingQuantity[t.topping_name] = 0;
          paidToppings.push(t);
        } else {
          const inCartFreeTopping = inCartAddedProduct?.extra_toppings?.find(
            (i) => !i.topping_price
          );
          if (inCartFreeTopping) {
            setSelectedFreeTopping(inCartFreeTopping);
          }
          freeToppings.push(t);
        }
      }

      setToppingQuantity(toppingQuantity);
      setFreeToppings(freeToppings);
      setPaidToppings(paidToppings);
      setDataReady(true);
      setProductQuantity(inCartAddedProduct?.selectedQuantity || 1);
    }
  }, [productDetail]);

  useEffect(() => {
    if (
      productsData?.errors === 'No kitchen exists.' ||
      productsData?.errors === 'There are no products available!'
    ) {
      const verbageText = `I'm sorry, but it seems like the restaurant you are searching for cannot be found. Don't worry, I'll redirect you to OnTheMenu where you can explore other amazing dining options!`;
      someThingWentWrong(verbageText);
      setIconForAlert(PRODUCT_NOT_FOUND_404);
      setIconWidth('250px');
    }
    // Url store name is not in localstorage ,should be redirect // ERROR LOOP
    if (!localStorageKitchens.split(',').includes(urlStoreName)) {
      const verbageText = `We're sorry, but it appears that the restaurant is unable to deliver to your current zipcode. You will be redirected to OnTheMenu`;
      setIconForAlert(STORE_NOT_FOUND_404);
      setIconWidth('250px');
      someThingWentWrong(verbageText);
    }

    if (Object.keys(sortedKitchenData).length === 0) {
      // If you are adding anything to setSortedKitchenData pls add that code on  [ Pdp.jsx, StoreMenu.jsx, PromotionalKitchenMenu.js OntheMenuDataProvider.jsx ]
      if (productsData?.data?.data?.[urlStoreName]?.product_count === 1) {
        setSortedKitchenData({
          ...sortedKitchenData,
          kitchenName: DataKitchenInfo?.kitchenName,
          kitchen_id: DataKitchenInfo?._id,
          account_type: DataKitchenInfo?.account_type,
          display_name: DataKitchenInfo?.display_name,
          display_image: DataKitchenInfo?.display_image,
          cuisine: DataKitchenInfo?.cuisine,
          meal_offering: DataKitchenInfo?.meal_offering,
          operation_start_time: DataKitchenInfo?.operation_start_time,
          operation_end_time: DataKitchenInfo?.operation_end_time,
          opening_status: DataKitchenInfo?.opening_status,
          delivery_agreement_fees: DataKitchenInfo?.delivery_agreement_fees,
          address: DataKitchenInfo?.Geolocation?.formattedAddress,
          deliveryPayAsYouGo_fee: DataKitchenInfo?.deliveryPayAsYouGo_fee,
          deliverySubscription_fee: DataKitchenInfo?.deliverySubscription_fee,
          delivery_type_available: DataKitchenInfo?.delivery_type_available,
          freePayAsYouGoDelivery: DataKitchenInfo?.freePayAsYouGoDelivery,
          freePayAsYouGoDelivery_TimeGap: DataKitchenInfo?.freePayAsYouGoDelivery_TimeGap,
          freeSubscriptionDelivery: DataKitchenInfo?.freeSubscriptionDelivery,
          freeSubscriptionDelivery_TimeGap: DataKitchenInfo?.freeSubscriptionDelivery_TimeGap,
          nearestKitchenNames: DataKitchenInfo?.nearestKitchenNames,
          storeIsClosedForShortTime: DataKitchenInfo?.storeIsClosedForShortTime,
          agreedForFreeComboPromo: DataKitchenInfo?.agreedForFreeComboPromo,
          amountRequiredForComboPromo: DataKitchenInfo?.amountRequiredForComboPromo,
          subscriptionMenuAvailable: DataKitchenInfo?.subscriptionMenuAvailable,
          regularMenuAvailable: DataKitchenInfo?.regularMenuAvailable,
          status: DataKitchenInfo?.status,
          delivered_by: DataKitchenInfo?.delivered_by,
          delivery_kitchen_fee: DataKitchenInfo?.delivery_kitchen_fee,
          restrictedDeliveryDay: DataKitchenInfo?.restrictedDeliveryDay,
          restrictedDeliveryStartTime: DataKitchenInfo?.restrictedDeliveryStartTime,
          restrictedDeliveryEndTime: DataKitchenInfo?.restrictedDeliveryEndTime,
          delivery_driver_shortage: DataKitchenInfo?.delivery_driver_shortage,
          pickup_order_promotion: DataKitchenInfo?.pickup_order_promotion,
          Geolocation: DataKitchenInfo?.Geolocation,
          package_plan: DataKitchenInfo?.package_plan,
          dedicated_drivers: DataKitchenInfo?.dedicated_drivers,
        });
      }
    }
  }, [JSON.stringify(productsData)]);

  useEffect(() => {
    if (
      isLoggedIn &&
      custActType &&
      notZeroPlates &&
      productDetail?.product_type === 'meal_item' &&
      productDetail?.available_quantity > 0
    ) {
      const remainingCategorizedProduct = getRemainingCategorisedProduct();
      if (remainingCategorizedProduct > 0) {
        setAddToCartDisabled(false);
      }
    }
  }, [JSON.stringify(cartItems)]);

  useEffect(() => {
    if (Object.keys(sortedKitchenData).length > 0 && StoreClosedForShortTime) {
      const verbageText = `Sorry store closed for some time, please visit back later.`;
      setIconForAlert(STORE_CLOSED_SHORT_TIME);
      someThingWentWrong(verbageText);
    }
    return;
  }, [sortedKitchenData]);

  const removeItem = (type, productSku, index, productCategory, promotionalItems) => {
    const newCartItems = cartItems[type].filter(
      (item, i) => !(item.product_sku === productSku && i === index)
    );
    const updatedCart = {
      ...cartItems,
      [type]: newCartItems,
    };
    if (promotionalItems) {
      updatedCart.promotionalItems = promotionalItems;
    }
    setCartItems(updatedCart);
  };

  const onAgreeAlert = (type) => {
    let promotionalItems = [];
    const newCartItems = JSON.parse(JSON.stringify(cartItems));
    if (type === 'payasyougo_combo') {
      promotionalItems = newCartItems?.promotionalItems?.filter(
        (item) => item.product_category !== 'payasyougo_combo'
      );
    } else if (type === 'subscription_combo') {
      promotionalItems = newCartItems?.promotionalItems?.filter(
        (item) => item.product_category !== 'subscription_combo'
      );
    } else {
      promotionalItems = newCartItems?.promotionalItems?.filter(
        (item) =>
          item.product_category !== 'payasyougo_combo' &&
          item.product_category !== 'subscription_combo'
      );
    }
    const index = newCartItems.nonMealItems?.findIndex(
      (item) => item.product_sku === openAlert.product?.product_sku
    );
    if (openAlert.triggerFrom === 'quantityUpdate') {
      if (productQuantity === 0) {
        newCartItems.nonMealItems = newCartItems.nonMealItems.filter(
          (item, i) => !(item.product_sku === openAlert.product?.product_sku && i === index)
        );
      } else {
        newCartItems.nonMealItems[index] = openAlert.product;
      }
      setCartItems({
        ...newCartItems,
        promotionalItems,
      });
      setOpenAlert({
        show: false,
        type: null,
        productType: null,
        productSku: null,
        index: -1,
        productCategory: null,
        triggerFrom: null,
        product: null,
        cartItems: null,
      });
      return;
    }
    removeItem(
      openAlert.productType,
      openAlert.productSku,
      index,
      openAlert.productCategory,
      promotionalItems
    );
    setOpenAlert({
      show: false,
      type: null,
      productType: null,
      productSku: null,
      index: -1,
      productCategory: null,
      triggerFrom: null,
      product: null,
      cartItems: null,
    });
  };

  const onDisagreeAlert = () => {
    setOpenAlert({
      show: false,
      type: null,
      productType: null,
      productSku: null,
      index: -1,
      productCategory: null,
      triggerFrom: null,
      product: null,
      cartItems: null,
    });
  };

  if (isLoading || productsData.isLoading) {
    return (
      <PageBase>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            marginTop: isMobile ? '20%' : '10%',
          }}
        >
          <Loader color='black' width='40px' height='40px' />
          <a> Loading... </a>
        </div>
      </PageBase>
    );
  }

  // We should capture this if block errors in new relic
  if (
    productsData.errors === 'Network Error' ||
    (errorMessage?.success === false &&
      errorMessage?.CustomMessage === 'Something is seriouly wrong,This is last CATCH block')
  ) {
    return <Error404 />;
  }

  // console.log('-------ButtonSwitch', ButtonSwitch())
  // console.log('---productDetail', { productDetail, freeToppings, paidToppings })
  // console.log('-----available_quantity', productDetail?.available_quantity)

  // We have this same code in productCart.jsx
  const productPromotionKeys = Object.keys(productDetail?.product_promotion || {});
  let productPromotionActiveKey = null;
  for (let i = 0; i < productPromotionKeys?.length; i++) {
    const key = productPromotionKeys[i];
    if (productDetail.product_promotion[key]) {
      productPromotionActiveKey = key;
      break;
    }
  }

  const checkPromoKeyName = productPromotionActiveKey === 'buy_one_get_half_price';
  const checkPromoKeyBuy2 = productPromotionActiveKey === 'buy_two_get_one_free';

  if (isMobile) {
    return (
      <div className='pdp-mobile-container'>
        <AlertDialog
          isLoading={false}
          open={isAlertOpen}
          setOpen={setAlertOpen}
          onAgree={onAlertAgree}
          onDisagree={onAlertDisagree}
          buttonAgreeLabel='Empty bag'
          buttonDisagreeLabel='Cancel'
          displayText='Start a new order ? Your bag contains items from another restaurant.Empty your bag to start a new order.'
          showAgreeButton
          showDisagreeButton
        />
        <AtomicButton
          label={`Back to ${urlStoreName}`}
          style={{
            height: '30px',
            backgroundColor: '#F2F2F2',
            marginTop: '1px',
            marginBottom: '5px',
            postion: 'relative',
            fontFamily: 'roboto regular',
            fontSize: '12px',
            color: '#181436',
            textTransform: 'capitalize',
          }}
          handleSubmit={handleClickRedirect}
          disabled={addToCartDisabled}
          endIcon={''}
          startIcon={<ArrowBackIcon sx={{ color: '#181436', fontSize: '20px' }} />}
        />
        <div className='pdp-mobile-image'>
          {productPromotionActiveKey && productDetail?.product_type === 'non_meal_item' && (
            <div
              style={{
                zIndex: 1,
                left: '8px',
                top: '8px',
                position: 'absolute',
                background: checkPromoKeyName
                  ? 'rgb(254, 236, 190)'
                  : checkPromoKeyBuy2
                    ? '#FF7A28'
                    : 'rgb(149, 237, 135)',
                color: checkPromoKeyBuy2 ? 'white' : '#181436',
                padding: '5px',
                width: 'auto',
                borderRadius: '5px',
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'center',
                fontSize: '12px',
                fontFamily: 'Roboto Medium',
                letterSpacing: '0.5px',
              }}
            >
              {' '}
              {TextTransformation(productPromotionActiveKey)}
            </div>
          )}

          {productCount > 0 && <div className='pdp-mobile-productcount'> {productCount}</div>}
          <img
            width={imageLoaded ? '100%' : 0}
            src={
              imageError
                ? fallBackImage
                : imageUrlTransformation({
                    imageUrl: product_image_url,
                    fillType: 'fill',
                    width: 370,
                  })
            }
            onLoad={() => onImageLoad()}
            onError={() => onImageError()}
            onClick={() => {
              // console.log("image clicked pdp desktop");
            }}
          />
        </div>
        <div className='pdp-product-name-mobile'>{productDetail?.product_name} </div>
        <div className='pdp-product-recipe-mobile'> {productDetail?.recipe_with} </div>

        <div style={{ display: 'flex', flexDirection: 'row' }}>
          {productDetail?.product_type === 'non_meal_item' && (
            <div
              style={{
                fontFamily: 'roboto bold',
                fontSize: '14px',
                margin: '0px 10px 7px 0px',
                color: '#3D3C3E',
              }}
            >
              ${productDetail?.price}
            </div>
          )}
          {productDetail?.product_type === 'meal_item' && (
            <div
              style={{
                fontSize: '12px',
                fontFamily: 'Roboto',
                color: '#FF7A28',
                marginBottom: '5px',
              }}
            >
              $0.00
            </div>
          )}

          {productDetail?.disabled && productDetail?.product_type === 'non_meal_item' && (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginLeft: '10px',
                width: '50px',
                borderRadius: '3px',
                color: 'white',
                fontSize: '10px',
                fontFamily: 'roboto medium',
                background: '#FF7A28',
                padding: '3px',
              }}
            >
              {' '}
              SOLD OUT
            </div>
          )}
        </div>

        <div style={{ display: 'flex', flexDirection: 'row', margin: '0px 5px 5px 00px' }}>
          {productDetail?.special_marking?.map((g, index) => {
            return (
              <Avatar
                alt='Remy Sharp'
                src={SpecialMarkingIcons[g]}
                sx={{ width: 20, height: 20, marginRight: '5px' }}
                key={`${index}_specialmarking`}
              />
            );
          })}
        </div>

        {freeToppings?.length > 0 && (
          <div className='pdp-free-topping-mobile'>
            <RadioGroup
              value={selectedFreeTopping?.topping_name || null}
              onChange={(v) => onFreeToppingSelected(v)}
              className='toppingGroupIpad'
            >
              <div className='choose-one-label-mobile'> Choose 1 </div>
              {freeToppings.map((t, i) => (
                <div className='free-topping-box-mobile' key={`${t.topping_name}_${i}`}>
                  <FormControlLabel
                    value={t.topping_name}
                    key={t.topping_name}
                    control={<Radio />}
                    label={t.topping_name}
                    labelPlacement='start'
                  />
                  <div className='free-topping-price-mobile'> ${t.topping_price}</div>
                </div>
              ))}
            </RadioGroup>
          </div>
        )}

        {paidToppings.length > 0 && (
          <div className='pdp-paid-topping-mobile'>
            <div className='extra-topping-label-mobile'> Extra Topping </div>
            {paidToppings?.map((p, i) => (
              <div key={`${p.topping_name}_${i}`} className='pdp-paid-box-container-mobile'>
                <div className='pdp-paid-mobile-section-1'>
                  <div>{p.topping_name}</div>
                </div>
                <div className='pdp-paid-mobile-section-2'>
                  <QuantityPicker
                    quantity={productQuantity === 0 ? 0 : toppingQuantity[p.topping_name] || 0}
                    maxCount={p.available_quantity}
                    disabled={productQuantity === 0}
                    onQuantityChange={(v) => {
                      updateSelectedToppingQuantity(p, v);
                    }}
                  />
                  <div className='paid-price-text-mobile'>${p.topping_price}</div>
                </div>
              </div>
            ))}
          </div>
        )}

        {productDetail?.product_type === 'meal_item' && (
          <AtomicButton
            label={ButtonSwitch().buttonLabel}
            style={{
              height: '40px',
              backgroundColor: `#181436`,
              postion: 'relative',
              fontSize: '14px',
            }}
            handleSubmit={ButtonSwitch().handleMethod}
            disabled={addToCartDisabled}
            endIcon={''}
            startIcon={''}
          />
        )}

        <div style={{ display: 'flex', flexDirection: 'row' }}>
          {productDetail?.product_type === 'non_meal_item' && (
            <div style={{ marginTop: '20px' }}>
              <QuantityPicker
                quantity={productQuantity}
                maxCount={productDetail?.available_quantity}
                onQuantityChange={(v) => {
                  if (v === 0) {
                    const updatedToppingQty = {};
                    Object.keys(toppingQuantity).forEach((k) => {
                      updatedToppingQty[k] = 0;
                    });
                    setToppingQuantity({ ...updatedToppingQty });
                  }
                  setProductQuantity(v);
                }}
                disabled={
                  productDetail?.available_quantity -
                    (cartItems?.nonMealItems?.find(
                      (item) =>
                        item.product_name === productDetail?.product_name &&
                        item.product_category === productDetail?.product_category
                    )?.selectedQuantity || 0) ===
                  0
                }
              />
            </div>
          )}

          {productDetail?.product_type === 'non_meal_item' && (
            <AtomicButton
              label={`Add to cart $${totalPriceOfNonMealItems.toFixed(2)}`}
              style={{
                height: '40px',
                backgroundColor: `#181436`,
                marginTop: '10px',
                postion: 'relative',
                fontSize: '14px',
              }}
              handleSubmit={onAddToCart}
              disabled={addToCartDisabled}
              endIcon={''}
              startIcon={''}
            />
          )}
        </div>
        {/* {IsCartItems && <AtomicButton
          label={`Go to checkout`}
          style={{
            height: "40px",
            backgroundColor: `#eeeeee`,
            marginTop: "2px",
            postion: "relative",
            fontSize: "16px",
            color: '#777778'
          }}
          handleSubmit={onClickCheckout}
          endIcon={""}
          startIcon={""}
        />} */}

        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div style={{ display: 'flex', flexDirection: 'row', margin: '10px 0px 0px 0px' }}>
            <button
              value='ingrediant'
              name='ingrediant'
              onClick={(e) => onButtonClick(e)}
              style={ActiveButton === 'ingrediant' ? ActiveStyle : InActiveStyle}
            >
              Ingrediant
            </button>

            <button
              value='ratings'
              name='ratings'
              onClick={(e) => onButtonClick(e)}
              style={ActiveButton === 'ratings' ? ActiveStyle : InActiveStyle}
            >
              Rating & Reviews
            </button>

            <button
              value='fresh'
              name='fresh'
              onClick={(e) => onButtonClick(e)}
              style={ActiveButton === 'fresh' ? ActiveStyle : InActiveStyle}
            >
              Fresh Ingrediant{' '}
            </button>
          </div>
          <div
            style={{
              overflow: 'hidden',
              backgroundColor: '#f9f9fa',
              border: '1px solid #cbc9cf',
              margin: '0px 5px 0px 5px',
              borderRadius: '5px',
            }}
          >
            Data coming soon
            {ActiveButton === 'fresh' && <Ingredients productDetail={productDetail} />}
          </div>
        </div>

        <div style={{ width: '200px', marginTop: '90px', border: '1px solid red' }}></div>

        <AlertDialog
          isLoading={false}
          open={open}
          // setOpen={true}
          onAgree={onAlertAgree}
          onDisagree={() => setOpen(false)}
          displayText={displayText}
          showAgreeButton={showAgreeButton}
          showDisagreeButton={showDisagreeButton}
          buttonAgreeLabel={buttonAgreeLabel}
          icon={iconForAlert}
          iconWidth={iconWidth}
        />
      </div>
    );
  }

  if (isIpad) {
    return (
      <PageBase>
        <AlertDialog
          isLoading={false}
          open={isAlertOpen}
          setOpen={setAlertOpen}
          onAgree={onAlertAgree}
          onDisagree={onAlertDisagree}
          buttonAgreeLabel='Empty bag'
          buttonDisagreeLabel='Cancel'
          displayText='Start a new order ? Your bag contains items from another restaurant.Empty your bag to start a new order.'
          showAgreeButton
          showDisagreeButton
        />

        <div className='pdp-ipad-container'>
          <div className='pdp-ipad-product'>
            <div className='pdp-image-ipad'>
              {productPromotionActiveKey && productDetail?.product_type === 'non_meal_item' && (
                <div
                  style={{
                    zIndex: 1,
                    left: '8px',
                    top: '8px',
                    position: 'absolute',
                    background: checkPromoKeyName
                      ? 'rgb(254, 236, 190)'
                      : checkPromoKeyBuy2
                        ? '#FF7A28'
                        : 'rgb(149, 237, 135)',
                    color: checkPromoKeyBuy2 ? 'white' : '#181436',
                    padding: '5px',
                    width: 'auto',
                    borderRadius: '5px',
                    alignItems: 'center',
                    display: 'flex',
                    justifyContent: 'center',
                    fontSize: '12px',
                    fontFamily: 'Roboto Medium',
                    letterSpacing: '0.5px',
                  }}
                >
                  {' '}
                  {TextTransformation(productPromotionActiveKey)}
                </div>
              )}

              {productCount > 0 && <div className='pdp-ipad-productcount'> {productCount}</div>}
              <img
                width={imageLoaded ? '100%' : '400px'}
                src={
                  imageError
                    ? fallBackImage
                    : imageUrlTransformation({
                        imageUrl: product_image_url,
                        fillType: 'fill',
                        width: 400,
                      })
                }
                onLoad={() => onImageLoad()}
                onError={() => onImageError()}
                onClick={() => {
                  // console.log("image clicked pdp desktop");
                }}
              />
              {!imageLoaded && <Loader color='black' width='40px' height='40px' />}
            </div>

            <div className='pdp-product-detail-ipad'>
              <AtomicButton
                label={`Back to ${urlStoreName}`}
                style={{
                  width: '250px',
                  height: '30px',
                  backgroundColor: `#F2F2F2`,
                  margin: '5px 0px 10px 10px',
                  postion: 'relative',
                  fontFamily: 'roboto regular',
                  fontSize: '12px',
                  color: '#181436',
                  textTransform: 'capitalize',
                }}
                handleSubmit={handleClickRedirect}
                disabled={addToCartDisabled}
                endIcon={''}
                startIcon={<ArrowBackIcon sx={{ color: '#181436', fontSize: '20px' }} />}
              />
              <div className='pdp-product-name-ipad'>{productDetail?.product_name} </div>
              <div className='pdp-product-recipe-ipad'> {productDetail?.recipe_with} </div>

              {productDetail?.product_type === 'non_meal_item' && (
                <div
                  style={{
                    fontFamily: 'roboto bold',
                    fontSize: '14px',
                    margin: '0px 10px 7px 10px',
                    color: '#3D3C3E',
                  }}
                >
                  ${productDetail?.price}
                </div>
              )}
              {productDetail?.disabled && productDetail?.product_type === 'non_meal_item' && (
                <div
                  style={{
                    marginLeft: '10px',
                    width: '50px',
                    borderRadius: '3px',
                    color: 'white',
                    fontSize: '10px',
                    background: '#FF7A28',
                    padding: '5px',
                  }}
                >
                  {' '}
                  SOLD OUT
                </div>
              )}
              {productDetail?.product_type === 'meal_item' && (
                <div
                  style={{
                    fontSize: '12px',
                    fontFamily: 'Roboto',
                    color: '#FF7A28',
                    margin: '0px 0px 0px 10px',
                  }}
                >
                  $0.00
                </div>
              )}

              <div style={{ display: 'flex', flexDirection: 'row', margin: '5px 5px 5px 10px' }}>
                {productDetail?.special_marking?.map((g, index) => {
                  return (
                    <Avatar
                      alt='Remy Sharp'
                      src={SpecialMarkingIcons[g]}
                      sx={{ width: 20, height: 20, marginRight: '5px' }}
                      key={`${index}_specialmarking`}
                    />
                  );
                })}
              </div>

              {freeToppings?.length > 0 && (
                <div className='pdp-free-topping-ipad'>
                  <RadioGroup
                    value={selectedFreeTopping?.topping_name || null}
                    onChange={(v) => onFreeToppingSelected(v)}
                    className='toppingGroupIpad'
                  >
                    <div className='choose-one-label-ipad'> Choose 1 </div>
                    {freeToppings.map((t, i) => (
                      <div className='free-topping-box-ipad' key={`${t.topping_name}_${i}`}>
                        <FormControlLabel
                          value={t.topping_name}
                          key={t.topping_name}
                          control={<Radio />}
                          label={t.topping_name}
                          labelPlacement='start'
                        />
                        <div className='free-topping-price-ipad'> ${t.topping_price}</div>
                      </div>
                    ))}
                  </RadioGroup>
                </div>
              )}

              {paidToppings.length > 0 && (
                <div className='pdp-paid-topping-ipad'>
                  <div className='extra-topping-label-ipad'> Extra Topping </div>
                  {paidToppings?.map((p, i) => (
                    <div key={`${p.topping_name}_${i}`} className='pdp-paid-box-container-ipad'>
                      <div className='pdp-paid-ipad-section-1'>
                        <div>{p.topping_name}</div>
                      </div>
                      <div className='pdp-paid-ipad-section-2'>
                        <QuantityPicker
                          quantity={
                            productQuantity === 0 ? 0 : toppingQuantity[p.topping_name] || 0
                          }
                          maxCount={p.available_quantity}
                          disabled={productQuantity === 0}
                          onQuantityChange={(v) => {
                            updateSelectedToppingQuantity(p, v);
                          }}
                        />
                        <div className='paid-price-text-ipad'>${p.topping_price}</div>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {productDetail?.product_type === 'meal_item' && (
                <AtomicButton
                  label={ButtonSwitch().buttonLabel}
                  style={{
                    width: '360px',
                    height: '40px',
                    backgroundColor: `#181436`,
                    margin: '10px',
                    postion: 'relative',
                    fontSize: '16px',
                  }}
                  handleSubmit={ButtonSwitch().handleMethod}
                  disabled={addToCartDisabled}
                  endIcon={''}
                  startIcon={''}
                />
              )}

              <div style={{ display: 'flex', flexDirection: 'row' }}>
                {productDetail?.product_type === 'non_meal_item' && (
                  <div style={{ marginTop: '20px' }}>
                    <QuantityPicker
                      quantity={productQuantity}
                      maxCount={productDetail?.available_quantity}
                      onQuantityChange={(v) => {
                        if (v === 0) {
                          const updatedToppingQty = {};
                          Object.keys(toppingQuantity).forEach((k) => {
                            updatedToppingQty[k] = 0;
                          });
                          setToppingQuantity({ ...updatedToppingQty });
                        }
                        setProductQuantity(v);
                      }}
                      disabled={
                        productDetail?.available_quantity -
                          (cartItems?.nonMealItems?.find(
                            (item) =>
                              item.product_name === productDetail?.product_name &&
                              item.product_category === productDetail?.product_category
                          )?.selectedQuantity || 0) ===
                        0
                      }
                    />
                  </div>
                )}

                {productDetail?.product_type === 'non_meal_item' && (
                  <AtomicButton
                    label={`Add to cart $${totalPriceOfNonMealItems.toFixed(2)}`}
                    style={{
                      width: '360px',
                      height: '40px',
                      backgroundColor: `#181436`,
                      marginTop: '10px',
                      postion: 'relative',
                      fontSize: '16px',
                    }}
                    handleSubmit={onAddToCart}
                    disabled={addToCartDisabled}
                    endIcon={''}
                    startIcon={''}
                  />
                )}
              </div>

              {IsCartItems && (
                <AtomicButton
                  label={`Go to checkout`}
                  style={{
                    width: productDetail?.product_type === 'meal_item' ? '360px' : '400px',
                    height: '40px',
                    backgroundColor: `#eeeeee`,
                    margin: '5px 0px 0px 10px',
                    postion: 'relative',
                    fontSize: '16px',
                    color: '#777778',
                  }}
                  handleSubmit={onClickCheckout}
                  endIcon={''}
                  startIcon={''}
                />
              )}
            </div>
          </div>

          <div className='pdp-ingredients-rating-review-video-container-ipad'>
            <div className='section-one'>
              <Ingredients productDetail={productDetail} />
            </div>
            <div className='section-two'>
              <div style={{ display: 'flex', flexDirection: 'row', margin: '10px 0px 0px 0px' }}>
                <button
                  value='ingrediant'
                  name='ingrediant'
                  onClick={(e) => onButtonClick(e)}
                  style={ActiveButton === 'ingrediant' ? ActiveStyle : InActiveStyle}
                >
                  Ingrediant
                </button>

                <button
                  value='ratings'
                  name='ratings'
                  onClick={(e) => onButtonClick(e)}
                  style={ActiveButton === 'ratings' ? ActiveStyle : InActiveStyle}
                >
                  Rating & Reviews
                </button>
              </div>
              <div
                style={{
                  backgroundColor: '#f9f9fa',
                  border: '1px solid #cbc9cf',
                  width: '360px',
                  height: '150px',
                  borderRadius: '5px',
                }}
              >
                Data coming soon
              </div>
            </div>
          </div>
        </div>
        <AlertDialog
          isLoading={false}
          open={open}
          // setOpen={true}
          onAgree={onAlertAgree}
          onDisagree={() => setOpen(false)}
          displayText={displayText}
          showAgreeButton={showAgreeButton}
          showDisagreeButton={showDisagreeButton}
          buttonAgreeLabel={buttonAgreeLabel}
          icon={iconForAlert}
          iconWidth={iconWidth}
        />
      </PageBase>
    );
  }

  const setMealsQuantity = (e, value) => {
    if (value !== null) {
      // setMealsQuantityState(value);
      // console.log('-----setMealsQuantity')
    }
  };

  const options = [
    { label: 'Menu', value: 'menu' },
    { label: 'Subscrition Menu', value: 'subscrition menu' },
  ];
  if (isDesktop) {
    return (
      <PageBase>
        <AlertDialog
          isLoading={false}
          open={isAlertOpen}
          setOpen={setAlertOpen}
          onAgree={onAlertAgree}
          onDisagree={onAlertDisagree}
          buttonAgreeLabel='Empty bag'
          buttonDisagreeLabel='Cancel'
          displayText='Start a new order ? Your bag contains items from another restaurant.Empty your bag to start a new order.'
          showAgreeButton
          showDisagreeButton
        />
        <div className='pdp-desktop-container'>
          <div className='pdp-product'>
            <div className='section-1'>
              <div className='section-one'>
                <div className='pdp-image'>
                  {productPromotionActiveKey && productDetail?.product_type === 'non_meal_item' && (
                    <div
                      style={{
                        zIndex: 1,
                        left: '8px',
                        top: '8px',
                        position: 'absolute',
                        background: checkPromoKeyName
                          ? 'rgb(254, 236, 190)'
                          : checkPromoKeyBuy2
                            ? '#FF7A28'
                            : 'rgb(149, 237, 135)',
                        color: checkPromoKeyBuy2 ? 'white' : '#181436',
                        padding: '5px',
                        width: 'auto',
                        borderRadius: '5px',
                        alignItems: 'center',
                        display: 'flex',
                        justifyContent: 'center',
                        fontSize: '12px',
                        fontFamily: 'Roboto Medium',
                        letterSpacing: '0.5px',
                      }}
                    >
                      {' '}
                      {TextTransformation(productPromotionActiveKey)}
                    </div>
                  )}

                  {productCount > 0 && <div className='pdp-productcount'> {productCount}</div>}
                  <img
                    width={imageLoaded ? '100%' : 0}
                    src={
                      imageError
                        ? fallBackImage
                        : imageUrlTransformation({
                            imageUrl: product_image_url,
                            fillType: 'fill',
                            width: 450,
                          })
                    }
                    onLoad={() => onImageLoad()}
                    onError={() => onImageError()}
                    onClick={() => {}}
                  />
                  {!imageLoaded && <Loader color='black' width='40px' height='40px' />}
                </div>
                <div className='pdp-product-info'>
                  <AtomicButton
                    label={`Back to ${urlStoreName}`}
                    style={{
                      width: '250px',
                      height: '30px',
                      backgroundColor: '#F2F2F2',
                      margin: '5px 0px 10px 10px',
                      postion: 'relative',
                      fontFamily: 'roboto regular',
                      fontSize: '12px',
                      color: '#181436',
                      textTransform: 'capitalize',
                    }}
                    handleSubmit={handleClickRedirect}
                    disabled={addToCartDisabled}
                    endIcon={''}
                    startIcon={<ArrowBackIcon sx={{ color: '#181436', fontSize: '20px' }} />}
                  />
                  <div className='pdp-product-name'>{productDetail?.product_name} </div>
                  <div className='pdp-product-recipe'> {productDetail?.recipe_with} </div>
                  {productDetail?.product_type === 'non_meal_item' && (
                    <div
                      style={{
                        fontFamily: 'roboto bold',
                        fontSize: '16px',
                        margin: '0px 10px 10px 10px',
                        color: '#3D3C3E',
                      }}
                    >
                      ${productDetail?.price}
                    </div>
                  )}
                  {productDetail?.disabled && productDetail?.product_type === 'non_meal_item' && (
                    <div
                      style={{
                        marginLeft: '10px',
                        width: '50px',
                        borderRadius: '3px',
                        color: 'white',
                        fontSize: '10px',
                        background: '#FF7A28',
                        padding: '5px',
                      }}
                    >
                      {' '}
                      SOLD OUT
                    </div>
                  )}
                  {productDetail?.product_type === 'meal_item' && (
                    <div
                      style={{
                        fontSize: '12px',
                        fontFamily: 'Roboto',
                        color: '#FF7A28',
                        margin: '0px 0px 0px 10px',
                      }}
                    >
                      $0.00
                    </div>
                  )}

                  <div
                    style={{ display: 'flex', flexDirection: 'row', margin: '10px 5px 5px 10px' }}
                  >
                    {productDetail?.special_marking?.map((g, index) => {
                      return (
                        <Avatar
                          alt='Remy Sharp'
                          src={SpecialMarkingIcons[g]}
                          sx={{ width: 20, height: 20, marginRight: '5px' }}
                          key={`${index}_specialmarking`}
                        />
                      );
                    })}
                  </div>
                  {freeToppings?.length > 0 && (
                    <div className='pdp-free-topping'>
                      <RadioGroup
                        value={selectedFreeTopping?.topping_name || null}
                        onChange={(v) => onFreeToppingSelected(v)}
                        className='toppingGroup'
                      >
                        <div className='choose-one-label'> Choose 1 </div>
                        {freeToppings.map((t, i) => (
                          <div className='free-topping-box' key={`${t.topping_name}_${i}`}>
                            <FormControlLabel
                              value={t.topping_name}
                              key={t.topping_name}
                              control={<Radio />}
                              label={t.topping_name}
                              labelPlacement='start'
                            />
                            <div className='free-topping-price'> ${t.topping_price}</div>
                          </div>
                        ))}
                      </RadioGroup>
                    </div>
                  )}

                  {paidToppings.length > 0 && (
                    <div className='pdp-paid-topping'>
                      <div className='extra-topping-label'> Extra Topping </div>
                      {paidToppings?.map((p, i) => (
                        <div key={`${p.topping_name}_${i}`} className='pdp-paid-box-container'>
                          <div className='pdp-paid-section-1'>
                            <div> {p.topping_name}</div>
                          </div>
                          <div className='pdp-paid-section-2'>
                            <QuantityPicker
                              quantity={
                                productQuantity === 0 ? 0 : toppingQuantity[p.topping_name] || 0
                              }
                              maxCount={p.available_quantity}
                              disabled={productQuantity === 0}
                              onQuantityChange={(v) => {
                                updateSelectedToppingQuantity(p, v);
                              }}
                            />
                            <div className='paid-price-text'>${p.topping_price}</div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  {productDetail?.product_type === 'meal_item' && (
                    <AtomicButton
                      label={ButtonSwitch().buttonLabel}
                      style={{
                        width: '360px',
                        height: '40px',
                        backgroundColor: `#181436`,
                        margin: '10px',
                        postion: 'relative',
                        fontSize: '16px',
                      }}
                      handleSubmit={ButtonSwitch().handleMethod}
                      disabled={addToCartDisabled}
                      endIcon={''}
                      startIcon={''}
                    />
                  )}

                  {productDetail?.product_type === 'non_meal_item' && (
                    <QuantityPicker
                      quantity={productQuantity}
                      maxCount={productDetail?.available_quantity}
                      onQuantityChange={(v) => {
                        if (v === 0) {
                          const updatedToppingQty = {};
                          Object.keys(toppingQuantity).forEach((k) => {
                            updatedToppingQty[k] = 0;
                          });
                          setToppingQuantity({ ...updatedToppingQty });
                        }
                        setProductQuantity(v);
                      }}
                      disabled={
                        productDetail?.available_quantity -
                          (cartItems?.nonMealItems?.find(
                            (item) =>
                              item.product_name === productDetail?.product_name &&
                              item.product_category === productDetail?.product_category
                          )?.selectedQuantity || 0) ===
                        0
                      }
                    />
                  )}

                  {productDetail?.product_type === 'non_meal_item' && (
                    <AtomicButton
                      label={`Add to cart $${totalPriceOfNonMealItems.toFixed(2)}`}
                      style={{
                        width: '360px',
                        height: '40px',
                        backgroundColor: `#181436`,
                        marginTop: '10px',
                        postion: 'relative',
                        fontSize: '16px',
                      }}
                      handleSubmit={onAddToCart}
                      disabled={addToCartDisabled}
                      endIcon={''}
                      startIcon={''}
                    />
                  )}
                  {/* {IsCartItems && <AtomicButton
                    label={`Go to checkout`}
                    style={{
                      width: productDetail?.product_type === "meal_item" ? "360px" : "402px",
                      height: "40px",
                      backgroundColor: `#eeeeee`,
                      margin: "2px 0px 0px 10px",
                      postion: "relative",
                      fontSize: "16px",
                      color: '#777778'
                    }}
                    handleSubmit={onClickCheckout}
                    endIcon={""}
                    startIcon={""}
                  />} */}
                </div>
              </div>

              <div className='pdp-ingredients-rating-review-video-container'>
                <div className='section-one'>
                  <Ingredients productDetail={productDetail} />
                </div>
                <div className='section-two'>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div
                      style={{ display: 'flex', flexDirection: 'row', margin: '10px 0px 0px 0px' }}
                    >
                      <button
                        value='ingrediant'
                        name='ingrediant'
                        onClick={(e) => onButtonClick(e)}
                        style={ActiveButton === 'ingrediant' ? ActiveStyle : InActiveStyle}
                      >
                        Ingrediant
                      </button>

                      <button
                        value='ratings'
                        name='ratings'
                        onClick={(e) => onButtonClick(e)}
                        style={ActiveButton === 'ratings' ? ActiveStyle : InActiveStyle}
                      >
                        Rating & Reviews
                      </button>
                    </div>
                    {ActiveButton === 'ingrediant' && (
                      <div
                        style={{
                          backgroundColor: '#f8fdf4',
                          border: '1px solid #bdeb9e',
                          width: '450px',
                          height: '150px',
                          borderRadius: '5px',
                        }}
                      >
                        Data comming soon for ingrediant
                      </div>
                    )}
                    {ActiveButton === 'ratings' && (
                      <div
                        style={{
                          backgroundColor: '#f9f9fa',
                          border: '1px solid #cbc9cf',
                          width: '450px',
                          height: '150px',
                          borderRadius: '5px',
                        }}
                      >
                        Data comming soon for rating and review
                      </div>
                    )}

                    <RadioGroupAtomic
                      options={options}
                      handleChange={setMealsQuantity}
                      value={'menu'}
                      className='radio-group-for-menu-tab-mobile'
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className='section-2'>{/* {IsCartItems ? <Cart /> : <EmptyCart />} */}</div>
          </div>
        </div>
        <AlertDialog
          isLoading={false}
          open={open}
          // setOpen={true}
          onAgree={onAlertAgree}
          onDisagree={() => setOpen(false)}
          displayText={displayText}
          showAgreeButton={showAgreeButton}
          showDisagreeButton={showDisagreeButton}
          buttonAgreeLabel={buttonAgreeLabel}
          icon={iconForAlert}
          iconWidth={iconWidth}
        />
        <AlertDialog
          isLoading={false}
          open={openAlert.show}
          onAgree={() => onAgreeAlert(openAlert.type)}
          buttonAgreeLabel='Proceed with Removal'
          buttonDisagreeLabel='Cancel'
          onDisagree={onDisagreeAlert}
          displayText={
            openAlert.type === 'payasyougo_combo' || openAlert.type === 'both'
              ? `Your nextday meal will be removed from the cart as the minimum order requirement in the cart is $${PromoSpendRequiredAmount()}`
              : 'Your nextday meal will be removed from the cart as the minimum order requirement is 1 subscription item in the cart.'
          }
          showAgreeButton
          showDisagreeButton
        />
      </PageBase>
    );
  }
};

export default Transition(Pdp);
